import React from "react";
import { useTheme } from "@material-ui/core";
import { VisibilityOff } from "@material-ui/icons";

import { StatusIcon } from "./StatusIcon";

export const NotPublicIcon = ({ record, ...props }) => {
  const theme = useTheme();

  if (record?.isPublic !== false) return null;
  return <StatusIcon
    tooltipText="resources.schedules.labels.not_public"
    icon={VisibilityOff}
    themeColor={theme.palette.warning}
    {...props}
  />
}
